<template>
    <div class="player-hand">
      <h3>{{ playerName }}'s Hand</h3>
      <div class="cards-container">
        <div v-for="(card, index) in cards" :key="index" class="card-wrapper">
          <span v-if="showOrder" class="card-order">{{ index + 1 }}</span>
          <Card 
            :number="card.number" 
            :color="card.color"
            :is-wildcard="card.isWildcard"
            :selected="isSelected(card)"
            @card-click="onCardClick"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Card from './CardVue.vue'
  
  export default {
    components: { Card },
    props: {
      playerName: {
        type: String,
        required: true
      },
      cards: {
        type: Array,
        default: () => []
      },
      selectedCard: {
        type: Object,
        default: null
      },
      showOrder: {
        type: Boolean,
        default: false
      }
    },
    emits: ['select-card'],
    methods: {
      isSelected(card) {
        if (!this.selectedCard) return false
        return card.number === this.selectedCard.number && 
               card.color === this.selectedCard.color
      },
      onCardClick(card) {
        this.$emit('select-card', card)
      }
    }
  }
  </script>
  
  <style scoped>
  .player-hand {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
  }
  
  h3 {
    margin-top: 0;
    color: #333;
    text-align: center;
  }
  
  .cards-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .card-wrapper {
    position: relative;
    display: inline-block;
    margin: 5px;
  }
  
  .card-order {
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    padding: 0 5px;
    border-radius: 50%;
    font-size: 12px;
    border: 1px solid #ccc;
  }
  </style>